import type { RecommerceAd } from "../types";
import { useAdClasses } from "./AdClasses";
import { AdExtras } from "./AdExtras";
import { AdImageWrapper } from "./AdImageWrapper";
import { AdLabel, SHIPPING_LABEL_IDS } from "./AdLabel";
import { AdLocation } from "./AdLocation";
import { AdPrice } from "./AdPrice";
import { AdTitle } from "./AdTitle";
import type { BaseAdProps } from "./AdTypes";
import { AdWrapper } from "./AdWrapper";

export const gridClasses = {
	mobile: {
		ad: "s-bg flex flex-col h-full",
		imageWrapper: "",
		image: "",
		content: "m-8 flex flex-col flex-1",
		heading: "break-words font-normal text-s",
		extras: "mt-4 mb-8",
		bottomLabels: "flex-col mt-auto",
		organisation: "mt-4",
		location: "mt-auto",
		secondaryLabel: "mt-auto",
		ribbon: "absolute top-0 left-0 pointer-events-none",
	},
	desktop: {
		organisation: "sm:mt-8",
		secondaryLabel: "",
		location: "",
		content: "sm:mb-16",
		heading: "mt-4",
		extras: "mt-4 mb-4",
	},
};

type AdProps = BaseAdProps & {
	ad: RecommerceAd;
	imageSizes?: string;
};

export function Ad(props: AdProps) {
	const { ad, className = "", heading, image, imageSizes, ...adProps } = props;

	const layoutClasses = gridClasses;
	const classes = useAdClasses({
		mode: adProps.mode,
		mobileClasses: layoutClasses.mobile,
		desktopClasses: layoutClasses.desktop,
	});

	const shippingExist = ad.labels?.some((label) => SHIPPING_LABEL_IDS.includes(label.id));

	return (
		<AdWrapper adId={ad.id} className={`${classes.ad} ${className}`} {...adProps}>
			<div className={classes.imageWrapper}>
				<AdImageWrapper ad={ad} image={image} imageClass={classes.image} sizes={imageSizes} />
			</div>
			<div className={classes.content}>
				<div className="flex flex-col flex-1 h-full">
					<AdPrice ad={ad} />
					<AdTitle
						ad={ad}
						className={`${classes.heading} ${ad.extras?.length > 0 ? "line-clamp-1" : "mb-8"}`}
						heading={heading}
					/>
					{ad.extras?.length > 0 && <AdExtras ad={ad} className={classes.extras} />}
					{shippingExist ? (
						<div className={`flex flex-wrap justify-between ${classes.bottomLabels}`}>
							<AdLabel ad={ad} className={classes.secondaryLabel} />
						</div>
					) : (
						<AdLocation ad={ad} className={classes.location} />
					)}
				</div>
			</div>
		</AdWrapper>
	);
}
